// DEV environment for a DEPLOYED build (angular.json "productionDev"): DEV branding, but with the
// service worker, so the deployed DEV site gets the same offline caching and "Update Application" prompts as PROD.
export const environment = {
  production: false,
  apiBaseUrl: '/api',
  appVersion: '5.0.0-dev',
  // Whether this build ships/registers the Angular service worker (offline cache + update prompts).
  serviceWorker: true,
  envLabel: 'DEV',
};
